import { render } from "./TextInfo.vue?vue&type=template&id=15b50903&scoped=true"
import script from "./TextInfo.vue?vue&type=script&lang=js"
export * from "./TextInfo.vue?vue&type=script&lang=js"

import "./TextInfo.vue?vue&type=style&index=0&id=15b50903&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b50903"]])

export default __exports__